"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OptionGroup", {
    enumerable: true,
    get: function() {
        return OptionGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useOptionGroup = require("./useOptionGroup");
const _renderOptionGroup = require("./renderOptionGroup");
const _useOptionGroupStylesstyles = require("./useOptionGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const OptionGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useOptionGroup.useOptionGroup_unstable)(props, ref);
    (0, _useOptionGroupStylesstyles.useOptionGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useOptionGroupStyles_unstable')(state);
    return (0, _renderOptionGroup.renderOptionGroup_unstable)(state);
});
OptionGroup.displayName = 'OptionGroup';
